export enum SubscriptionOnboardingErrorCode {
  SUBSCRIPTION_ONBOARDING_ALREADY_COMPLETED = 'SUBSCRIPTION_ONBOARDING_ALREADY_COMPLETED',
  SUBSCRIPTION_ONBOARDING_INVALID_LINK = 'SUBSCRIPTION_ONBOARDING_INVALID_LINK',
}
